import React, { useEffect } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import Login from "../pages/Login";
import { Products } from "../pages/Products";
import { hotjar } from 'react-hotjar';

if (process.env.REACT_APP_HOTJAR_ID) {
  hotjar.initialize({
    id: parseInt(process.env.REACT_APP_HOTJAR_ID, 10),
    sv: 6
  });
}

const HotjarTracker = () => {
  const location = useLocation();

  useEffect(() => {
    console.log('location.pathname@@##', process.env.REACT_APP_HOTJAR_ID);
    if (process.env.REACT_APP_HOTJAR_ID) {
      hotjar.stateChange(location.pathname);
      hotjar.event(`page_view_${location.pathname.replace('/', '') || 'home'}`);
    }
  }, [location]);

  return null;
};

export const AppRoutes = () => {

  return (
    <>
      <HotjarTracker />
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/products" element={<Products />} />
      </Routes>
    </>
  )
};
